import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class InvestorGoalError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('InvestorGoalError', ...args);
    }
}
export default InvestorGoalError;
